// saga.ts
import { call, put, takeEvery } from 'redux-saga/effects';
import {
    createEmployee,
    createUserRights,
    deleteEmployee,
    getEmployeeApi,
    getUserRightsApi,
    updateEmployee,
    updateEmployeeCredentials,
    updateEmployeeStatus,
} from '../../api/EmployeeApi'; // Adjust the path as needed
import {
    getEmployeeSuccess,
    getEmployeeFailure,
    createEmployeeSuccess,
    createEmployeeFailure,
    updateEmployeeSuccess,
    updateEmployeeFailure,
    deleteEmployeeSuccess,
    deleteEmployeeFailure,
    getUserRightsFailure,
    getUserRightsSuccess,
    createUserRightsSuccess,
    createUserRightsFailure,
} from './actions';

// Saga to handle fetching Employees
function* fetchEmployeeSaga(action: any): Generator<any, any, any> {
    try {
        const data = yield call(getEmployeeApi, action.payload);
        yield put(getEmployeeSuccess(data));
    } catch (error: any) {
        const errorMessage = error?.response?.data?.meta?.message
            ? error.response
            : error?.message
            ? error.message
            : 'An unexpected error occurred';

        yield put(getEmployeeFailure(errorMessage));
    }
}

function* fetchUserRightsSaga(action: any): Generator<any, any, any> {
    try {
        const data = yield call(getUserRightsApi, action.payload.id);
        yield put(getUserRightsSuccess(data));
    } catch (error: any) {
        const errorMessage = error?.response?.data?.meta?.message
            ? error.response
            : error?.message
            ? error.message
            : 'An unexpected error occurred';

        yield put(getUserRightsFailure(errorMessage));
    }
}

// // Saga to handle creating a Employee
function* createEmployeeSaga(action: any): Generator<any, any, any> {
    try {
        const data = yield call(createEmployee, action.payload);
        yield put(createEmployeeSuccess(data));
    } catch (error: any) {
        const errorMessage = error?.response?.data?.meta?.message
            ? error.response
            : error?.message
            ? error.message
            : 'An unexpected error occurred';

        yield put(createEmployeeFailure(errorMessage));
    }
}

// // Saga to handle creating a Employee
function* createUserRightsSaga(action: any): Generator<any, any, any> {
    try {
        const data = yield call(createUserRights, action.payload);
        yield put(createUserRightsSuccess(data));
    } catch (error: any) {
        const errorMessage = error?.response?.data?.meta?.message
            ? error.response
            : error?.message
            ? error.message
            : 'An unexpected error occurred';

        yield put(createUserRightsFailure(errorMessage));
    }
}

// // Saga to handle updating a Employee
function* updateEmployeeSaga(action: any): Generator<any, any, any> {
    try {
        const data = yield call(updateEmployee, action.payload.data, action.payload.id);
        yield put(updateEmployeeSuccess(data));
    } catch (error: any) {
        const errorMessage = error?.response?.data?.meta?.message
            ? error.response
            : error?.message
            ? error.message
            : 'An unexpected error occurred';

        yield put(updateEmployeeFailure(errorMessage));
    }
}

function* updateEmployeeStatusSaga(action: any): Generator<any, any, any> {
    try {
        const data = yield call(updateEmployeeStatus, action.payload.data, action.payload.id);
        yield put(updateEmployeeSuccess(data));
    } catch (error: any) {
        const errorMessage = error?.response?.data?.meta?.message
            ? error.response
            : error?.message
            ? error.message
            : 'An unexpected error occurred';

        yield put(updateEmployeeFailure(errorMessage));
    }
}

function* updateEmployeeCredentialsSaga(action: any): Generator<any, any, any> {
    try {
        const data = yield call(updateEmployeeCredentials, action.payload.data, action.payload.id);
        yield put(updateEmployeeSuccess(data));
    } catch (error: any) {
        const errorMessage = error?.response?.data?.meta?.message
            ? error.response
            : error?.message
            ? error.message
            : 'An unexpected error occurred';

        yield put(updateEmployeeFailure(errorMessage));
    }
}

// // Saga to handle updating a Employee
function* deleteEmployeeSaga(action: any): Generator<any, any, any> {
    try {
        const data = yield call(deleteEmployee, action.payload.id);
        yield put(deleteEmployeeSuccess(data));
    } catch (error: any) {
        const errorMessage = error?.response?.data?.meta?.message
            ? error.response
            : error?.message
            ? error.message
            : 'An unexpected error occurred';
        yield put(deleteEmployeeFailure(errorMessage));
    }
}

export default function* EmployeeSaga() {
    yield takeEvery('GET_EMPLOYEE_REQUEST', fetchEmployeeSaga);
    yield takeEvery('GET_USER_RIGHTS_REQUEST', fetchUserRightsSaga);
    yield takeEvery('CREATE_EMPLOYEE_REQUEST', createEmployeeSaga);
    yield takeEvery('CREATE_USER_RIGHTS_REQUEST', createUserRightsSaga);
    yield takeEvery('UPDATE_EMPLOYEE_REQUEST', updateEmployeeSaga);
    yield takeEvery('UPDATE_EMPLOYEE_STATUS_REQUEST', updateEmployeeStatusSaga);
    yield takeEvery('UPDATE_EMPLOYEE_CREDENTIALS_REQUEST', updateEmployeeCredentialsSaga);
    yield takeEvery('DELETE_EMPLOYEE_REQUEST', deleteEmployeeSaga);
}
